import React, { ReactElement } from 'react';
import { handleReturnWithLazy } from '../../utils/globals';
import { returnComponentFromPath } from '../Utils/returnComponentFromPath';

interface ComponentProps {
  title: string;
}

export const Component = (props: ComponentProps): ReactElement => {
  const { type, anchorId, color, isLazy, title } = props;

  const componentToReturn = color ? (
    <div
      className={`flex bg-${color.classname} w-screen justify-center relative`}
      id={title}
    >
      <div className='main-wrapper w-full'>
        {returnComponentFromPath(props)}
      </div>
    </div>
  ) : (
    returnComponentFromPath(props)
  );

  // return a specfic element type
  if (type) {
    const elementToReturn = React.createElement(
      type,
      { id: anchorId || title, className: 'anchor-scroll-margin w-full' },
      componentToReturn
    );

    return handleReturnWithLazy(elementToReturn, false); // isLazy);
  }

  return handleReturnWithLazy(componentToReturn, false); // isLazy);
};
